import React, { useMemo } from "react";
import { useRouteMatch } from "react-router-dom";

import { Stack } from "@mui/material";
import { EmailBox } from "components";
import { ClientWorkspaceProvider } from "components/Client-workspace/context/ClientWorkspace-context";
import { DataBox } from "components/Client-workspace/DataBox";
import { WorkspaceContentModal } from "components/Client-workspace/WorkspaceContentModal";
import { WorkspaceMetadata } from "components/Client-workspace/WorkspaceMetadata";
import { Routes } from "constants/routes";

interface Props {}

const modalRoutes = [Routes.dealForm, Routes.dealFile, Routes.dealNote, Routes.dealDocument];

export const WorkspaceTab: React.FC<Props> = () => {
  const isModalOpen = !!modalRoutes.some((route) => useRouteMatch(route));

  const emailMatch = useRouteMatch(Routes.dealEmails);

  const content = useMemo(() => {
    if (emailMatch) return <EmailBox />;
    return <WorkspaceMetadata />;
  }, [emailMatch]);

  return (
    <ClientWorkspaceProvider>
      <Stack sx={{ width: "100%", height: "100%", backgroundColor: "#f6f8fc" }} direction="row" gap="10px">
        <DataBox />
        <Stack
          sx={{
            width: "100%",
            height: "100%",
            minWidth: 0,
            padding: "10px 16px",
            borderRadius: "8px",
            backgroundColor: "#fff",
            overflow: "hidden"
          }}
        >
          {content}
        </Stack>
      </Stack>
      <WorkspaceContentModal open={isModalOpen} />
    </ClientWorkspaceProvider>
  );
};
